import React from 'react';
import { Container } from '../Container';
import { Section } from '../Section';
import { Reveal } from '../Reveal';
import { AppImage } from '../AppImage';
import { story } from '../../data/about';
import { aboutStoryImage } from '../../data/aboutImages';
export function StorySection() {
  return <Section bordered labelledBy="story-title" data-id="element-67" data-mp="348uzswgdi0tn">
      <Container data-id="element-68" data-mp="34835doyii94y">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-10" data-id="element-69" data-mp="34bqxcjob6nhk">
          <div className="lg:col-span-4" data-id="element-70" data-mp="3i7kxoeb0o4j2">
            <Reveal data-id="element-71" data-mp="3da2l8dxsj76b">
              <h2 id="story-title" className="max-w-[12ch] text-[40px] leading-[1.05] tracking-[-0.03em] text-ink lg:text-[56px]" data-id="element-72" data-mp="3dakohuivelnq">
                {story.heading}
              </h2>
              <AppImage src={aboutStoryImage.image} alt={aboutStoryImage.alt} ratio="3:4" className="mt-10 max-w-[320px]" data-id="element-73" data-mp="3n1743oql7c6f" />
            </Reveal>
          </div>

          <div className="lg:col-span-7 lg:col-start-6" data-id="element-74" data-mp="3vypqawfyvwjw">
            <div className="space-y-7" data-id="element-75" data-mp="3buixh14briob">
              {story.paragraphs.map((paragraph, index) => <Reveal key={paragraph.slice(0, 32)} delay={index * 0.05} data-id="element-76" data-mp="3gsu9nii3e59p" data-mpi={index}>
                  <p className={index === 0 ? 'max-w-measure text-[20px] leading-[1.55] text-ink lg:text-[22px]' : 'max-w-measure text-body text-muted'} data-id="element-77" data-mp="3lr5grlh061o8">
                    {paragraph}
                  </p>
                </Reveal>)}
            </div>
          </div>
        </div>
      </Container>
    </Section>;
}